import { AuthSource } from '@framework/auth/AuthSource.ts';
import { ExternalUserLoginForm } from '@framework/auth/components/external/ExternalUserLoginForm.tsx';
import { useLogin } from '@framework/auth/components/login/useLogin.tsx';
import { MockLoginForm } from '@framework/auth/strategies/mock/MockLoginForm.tsx';
import { useHistory } from '@framework/ui/core/router/TypedRoute.tsx';
import { FrontLoginForm } from '#theme';
import { appConfig, resolveApiPath } from '../../../core/appConfig.ts';

interface Props {}

/**
 * Form di login all'applicativo, tramite le API di creazione AccessToken JWT.
 */
export function LoginForm(props: Props) {
  const history = useHistory();

  const onLogin = useLogin(history);

  // Form **reale** di login
  if (!appConfig.mockLogin) {
    return (
      <FrontLoginForm
        loading={false}
        resolvePublicUrl={resolveApiPath}
        onLogin={onLogin}
        externalLogin={<ExternalUserLoginForm onLogin={onLogin} />}
      />
    );
  }

  // Form **mock** di login
  return (
    <MockLoginForm source={AuthSource.FrontOffice}>
      <FrontLoginForm
        loading={false}
        resolvePublicUrl={resolveApiPath}
        externalLogin={<ExternalUserLoginForm onLogin={onLogin} />}
        onLogin={onLogin}
      />
    </MockLoginForm>
  );
}
